import { usePathname, useRouter } from 'next/navigation'

const useQueryParams = () => {
  const pathname = usePathname()
  const router = useRouter()

  const removeQueries = (keys: string[]) => {
    const searchParams = new URLSearchParams(window.location.search)
    keys.forEach((key) => {
      if (searchParams.has(key)) {
        searchParams.delete(key)
      }
    })
    const newUrl = `${pathname}?${searchParams.toString()}`
    router.push(newUrl)
  }

  const addQueries = (keysValues: Record<string, string | string[]>) => {
    const searchParams = new URLSearchParams(window.location.search)

    Object.entries(keysValues).forEach(([key, value]) => {
      if (value) {
        const valueString = Array.isArray(value) ? value.join() : value
        searchParams.set(key, valueString)
      } else {
        searchParams.delete(key)
      }
    })

    const newUrl = `${pathname}?${searchParams.toString()}`
    router.push(newUrl)
  }

  return { removeQueries, addQueries }
}

export default useQueryParams
